import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_ACCESS_RULES } from '../get-access-rules';
import { createAccessRulesAPI } from './api';

export function useCreateAccessRule(onSuccess) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation((data) => createAccessRulesAPI(data), {

    onSuccess: () => {
      queryClient.invalidateQueries([GET_ACCESS_RULES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'success', description: 'accessRuleCreatedSuccessfully' },
      });

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error) => {
      if (error?.errorMessage?.includes('already exists')) {
        openModal({
          modalType: 'NotificationModal',
          modalProps: { type: 'error', description: 'accessRuleNameAlreadyExists' },
        });
      } else {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      }
    },
  });

  return {
    createAccessRule: mutation.mutate,
    createAccessRuleAsync: mutation.mutateAsync,
    ...mutation,
  };
}

